import type { EventKind, ScheduleKindFilter } from "@/types/schedule";

/** Kind filter pills shown on the schedule page (spot polls deferred). */
export const SCHEDULE_KIND_OPTIONS: {
  value: ScheduleKindFilter;
  label: string;
}[] = [
  { value: "all", label: "All events" },
  { value: "departure", label: "Departures" },
  { value: "arrival", label: "Arrivals" },
  { value: "cutoff", label: "Cutoffs" },
  { value: "stuffing", label: "Stuffing" },
];

export const EVENT_KIND_LABELS: Record<EventKind, string> = {
  departure: "Departure",
  arrival: "Arrival",
  cutoff: "Cutoff",
  spot: "Spot poll",
  stuffing: "Stuffing",
};

/** Kinds rendered in the legend, in display order (spot deferred for v1). */
export const SCHEDULE_LEGEND_KINDS: EventKind[] = [
  "departure",
  "arrival",
  "cutoff",
  "stuffing",
];

/** Solid dot color per kind, used by the legend and day/month views. */
export const EVENT_DOT_COLORS: Record<EventKind, string> = {
  departure: "bg-sky-500",
  arrival: "bg-teal-500",
  cutoff: "bg-amber-500",
  spot: "bg-emerald-500",
  stuffing: "bg-violet-500",
};
